import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VForm,
        {
          ref: "form",
          staticClass: "form mt-2",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            VRow,
            { attrs: { dense: "dense" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSelect, {
                    attrs: {
                      label: "Tipo de Usuario",
                      items: ["Lider", "Equipo", "Negocio", "Data"],
                      rules: _vm.rules.user_type,
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.tipoUsuario,
                      callback: function ($$v) {
                        _vm.tipoUsuario = $$v
                      },
                      expression: "tipoUsuario",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "6" } },
                [
                  _c(VTextField, {
                    attrs: {
                      label: _vm.$t("attributes.label.users"),
                      placeholder: _vm.$t("attributes.placeholder.input_user"),
                      rules: _vm.rules.email,
                      outlined: "",
                      "hide-details": "auto",
                      dense: "",
                      disabled: _vm.isEditMode,
                    },
                    model: {
                      value: _vm.newUser,
                      callback: function ($$v) {
                        _vm.newUser = $$v
                      },
                      expression: "newUser",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", block: "", type: "submit" },
                      on: { click: _vm.onAssignUser },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(VTextField, {
                    staticClass: "mt-1",
                    attrs: {
                      "append-icon": "mdi-magnify",
                      label: "Buscar",
                      "single-line": "",
                      "hide-details": "",
                      dense: "",
                      outlined: "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                  _c(VDataTable, {
                    key: _vm.keyTable,
                    staticClass: "table-inca elevation-2",
                    attrs: {
                      items: _vm.filteredItems,
                      headers: _vm.headers,
                      dense: "",
                      "hide-default-footer": true,
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                      loading: _vm.isLoading,
                      disabled: _vm.isLoading,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.actions",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "btn-icon-inca",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onEditUser(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v("mdi-pencil"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Editar usuario")])]
                            ),
                            _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "btn-icon-inca",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onRevokeUser(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v(
                                                  "mdi-minus-circle-outline"
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Eliminar usuario")])]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_CONFIRMATION,
        attrs: {
          title: "Confirmación",
          text:
            "¿Está seguro de eliminar a  " + _vm.itemEliminar.applicant + "?",
        },
        on: { onConfirm: _vm.onSubmitConfirmation },
      }),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }